// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    hubNotFound: {
        id: 'install-nano1-upgrade.alerts.not-found',
        description: 'Hub search failure',
        defaultMessage: 'Sorry, we cannot find your Hub - check its ID number and internet connection.'
    },
    hubOffline: {
        id: 'install-nano1-upgrade.alerts.offline',
        description: 'If source or destination hub are offline',
        defaultMessage: 'Please confirm both hubs are connected with power and broadband, then try again'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/install-nano1-upgrade/intl.js